// Business Contact Form Data Types and Constants

import ApiGet from "../../../../api-module/api-configuration/get-api/getApi";
import { CountryOption } from "../../../../component-module/component-services/input/phone-number";
import { API_ENDPOINTS } from "../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider";

export interface BusinessContactFormData {
  businessName: string;
  businessEmail: string;
  inquiresType: string;
  country: string;
  phone: string;
  message: string;
  consent: boolean;
  dialCode: string;
}

export const initialBusinessContactFormData: BusinessContactFormData = {
  businessName: '',
  businessEmail: '',
  inquiresType: '',
  dialCode: '',
  country: '',
  phone: '',
  message: '',
  consent: false
};

export const inquiryOptions = [
  { value: 'general', label: 'General Inquiry' },
  { value: 'partnership', label: 'Partnership & Collaboration' },
  { value: 'support', label: 'Support & Feedback' }
];

export const switchContactItems = (navigate: (path: string) => void) => [
  {
    id: '1',
    description: 'Our sale experts are here to help you.',
    buttonText: 'Inquires us',
    onButtonClick: () => navigate('/contact/sales-contact'),
  },
  {
    id: '2',
    description: 'Join our team and grow your careers',
    buttonText: 'Join us',
    onButtonClick: () => navigate('/career'),
  }
];

export type BusinessContactPageData = {
  businessContact: BusinessContactContent;
};

export type BusinessContactContent = {
  key: string;
  title: string;
  visible: boolean;
  cta: BusinessContactCta[];
};

export type BusinessContactCta = {
  bussinessContactSection?: BussinessContactSection;
};

export type BussinessContactSection = {
  key: string;
  visible: boolean;
  content: Array<{
    headerSection?: BussinessContactHeaderSection;
    breadCrumbSection?: BussinessContactBreadCrumbSection;
  }>;
};

export type BussinessContactHeaderSection = {
  key: string;
  title?: string;
  description?: string;
  visible: boolean;
  lists: BussinessContactListItem[];
};

export type BussinessContactListItem = {
  id: number;
  label: string;
  title: string;
};

export type BussinessContactBreadCrumbSection = {
  key: string;
  visible: boolean;
  breadCrumbTitleNd?: string;
  breadCrumbTitleSt?: string;
};

export interface CountryApiItem {
  iso: string;
  name: string;
  dialCode: string;
  flag: string;
}

export interface CountryApiResponse {
  success: boolean;
  requestId: string;
  data: CountryApiItem[];
}

 /* istanbul ignore next */
export const mapCountryOptions = (countries: CountryApiItem[]): CountryOption[] => {
  return countries.map((c) => ({
    code: c.iso,
    name: c.name,
    dialCode: c.dialCode,
    flag: c.flag,
  }));
};

 /* istanbul ignore next */
export const getCountry = () =>
  ApiGet<CountryApiResponse>(API_ENDPOINTS.GET_COUNTRY);